 
import React, { useState } from "react";
import VStack from "../../ui_atoms/VStack";
import { SwipeButton } from "../../components/SwipeButton";
import Text from "../../components/Text";
import type { Meta, StoryObj } from "@storybook/react";

function ComponentStory() {
    const [result, setResult] = useState("");

    return (
        <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch" }}>
            <Text>{result}</Text>
            <SwipeButton title="disabled" disabled />
            <SwipeButton title="processing" processing />
            <SwipeButton
                title="Small swipe but with a large title that may overflow in both direction"
                size="small"
                onSwipeSuccess={() => setResult("Small")}
            />

            <SwipeButton
                title="With icon"
                onSwipeSuccess={() => setResult("With icon")}
                thumbIconName="swipe-right"
            />
            <SwipeButton
                title="Long processing"
                onSwipeSuccess={async () => {
                     
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    setResult("Long processing");
                }}
                thumbIconName="swipe-right"
            />
            <SwipeButton
                title="Danger action"
                onSwipeSuccess={() => setResult("With icon")}
                thumbIconName="chevron-right"
                mode="danger"
            />
        </VStack>
    );
}

const meta = {
    title: "Components/Swipe button",
    component: ComponentStory,
    argTypes: {},
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
